var Transfer = require("@/common/transfer");

module.exports = new Transfer(null, "toHost", true);
